module.exports = __webpack_public_path__ + "img/bihMapa.a32f7a95.jpg";